import axios from 'axios'
import router from '@/router'
import store from '../store'
import {
    Loading,
    message
} from 'element-ui'
// axios封装
let nowHttp = {},
  urlCount = 0,
  httpCancel, loadServeice;
let delLoad = (loadTimer) => {
    clearTimeout(loadTimer);
    if (urlCount) urlCount--;
    if (!urlCount) {
      loadServeice && loadServeice.close();
      loadServeice = null
    }
}
let errMessage = (text, type) => {
    setTimeout(() => message({
      showClose: true,
      message: text,
      type: type || 'error'
    }), 0)
}

export default ({url, data = {}, options = {}})=>{
    // 生产环境
    // if( process.env.NODE_ENV === 'production' ){
    //     url = 'https://api.qrgraph.com' + url
    // }
    data = {
        ...data
    };
    let {
        method = 'post', 
        load = 1, 
        api = 0, 
        loadOpts = {}, 
        json = 0,
        excel = 0,
        file = 0
    } = options,
    loadDelayTime = 400,
    loadOptsDefault = {
        background: 'rgba(255, 255, 255, 0.4)'
    },
    loadTimer = null,
    postdata = '',
    params = {};
    loadOptsDefault = Object.assign(loadOptsDefault, loadOpts);

    let token = localStorage.getItem('token') || store.getters['user/TOKEN'];
    let refresh_token = localStorage.getItem('refresh_token') || store.getters['user/REFRESH_TOKEN'];
    let access_token = localStorage.getItem('access_token') || store.getters['user/ACCESS_TOKEN'];
    
    let axiosConfig = {
        timeout: 100000,
        // withCredentials: true,
        // baseURL: api ? config.api_api_url : config.api_url,
        cancelToken: new axios.CancelToken(c => httpCancel = c),
        headers: {
          'Content-Type': json ? 'application/json' : 'application/x-www-form-urlencoded',
          'token': `${token};${refresh_token};${access_token}`
            // 'filename': file?'utf-8':null,
        },
        responseType:excel?'blob':null
    };
    const instance = axios.create(axiosConfig);
    instance.interceptors.request.use(config => {
        
        return config
    }, error => Promise.reject(error));
    instance.interceptors.response.use(function (response) {
        return response;
      }, function (error) {
        return Promise.reject(error);
    });
    if (excel) params.responseType = "arraybuffer";
    return new Promise((resolve, reject) => {
        if (load) {
            //如果请求速度很快无需loading,延迟500ms
            loadTimer = setTimeout(() => {
              if (!loadServeice) loadServeice = Loading.service(loadOptsDefault);
              clearTimeout(loadTimer);
              urlCount++
            }, loadDelayTime)
        }
        if(file){
            // console.log(data);
            let keys = Object.keys(data);
            postdata = new FormData();
            keys.forEach(k=>{
                if(k === 'files'){
                    for(let i=0;i<data.files.length;i++){
                        postdata.append(`file[${i}]`, data.files[i]);
                    }
                    // postdata.append("file", data.files[0]);
                }else if(k === 'file'){
                    postdata.append(`file`, data.file);
                }
                else{
                    postdata.append(k, data[k])
                }
            })
            // console.log(postdata,data)
        }else{
            if (json){
                postdata = JSON.stringify(data);
            }else {
                let p = [];
                for (let key in data) {
                    let d = data[key];
                    if( Array.isArray(d) ){
                        d.forEach((v,i)=>{
                            p.push(`${key}[${i}]` + '=' + v);
                        })
                    }else{
                        d = encodeURIComponent(d);
                        p.push(key + '=' + d);
                    }
                    // d = Array.isArray(d) ? encodeURIComponent(d.join(',')) : encodeURIComponent(d)
                }
                postdata = p.join('&');
            }
        }
        if (method === 'post' || json || method === 'put'){ 
            params = {
                method,
                url,
                data: postdata
            }
        }else{
            params = {
                method,
                url: url + '?' + postdata
            }
        }
        return instance(params).then((res)=>{
            let { data, headers } = res;
            if (load) delLoad(loadTimer);
            // 更新refreshtoken accesstoken
            if( data.data && data.data.refresh_token ){
                store.commit('user/SET_REFRESH_TOKEN',data.data.refresh_token);
                localStorage.setItem('refresh_token',data.data.refresh_token)
            }
            if( data.data && data.data.access_token ){
                store.commit('user/SET_ACCESS_TOKEN',data.data.access_token);
                localStorage.setItem('access_token',data.data.access_token)
            }
            if( excel ){
                // 导出
                if( headers['content-disposition'] ){
                    let filename = headers['content-disposition'].split('filename="')[1].split('.csv')[0];
                    let blob = new Blob([data],{type:'application/vnd.ms-excel'});
                    let href = URL.createObjectURL(blob) //创建新的URL表示指定的blob对象
                    let a = document.createElement('a') //创建a标签
                    a.style.display = 'none'
                    a.href = href // 指定下载链接
                    a.download = filename //指定下载文件名
                    a.click() //触发下载
                    URL.revokeObjectURL(a.href) //释放URL对象
                }else{
                    errMessage('暂无数据导出');
                }
            }else{
                if( data.code === 0 || data.errno === 0){
                    if( data.data.data ){
                        resolve(data.data.data);
                    }else{
                        resolve(data.data);
                    }
                }else{
                    errMessage(data.msg);
                    // 个人信息出错 跳登录
                    if( data.code === 102 ){
                        router.replace({name:'login'})
                    }
                } 
            }
        }).catch(err=>{
            if (load) delLoad(loadTimer);
            reject(err);
            errMessage('服务出错，请稍后再试');
            // router.replace({
            //     name: 'login'
            // });
        })
    })
}


// WEBPACK FOOTER //
// ./src/common/require.js